import React from "react";
import { ListContainer } from "./style";
import ProductBox from "components/productBox";
import EmptyState from "components/emptyState";
const List = ({ items, select,showPic }) => {
  if (!items) return <EmptyState message="ارتباط با سرور با مشکل روبه‌رو شد" />;
  return (
    <ListContainer>
      <h5>لیست خودرو های موجود</h5>
      {items.length === 0 ? (
        <EmptyState message="در حال حاضر بخش نامه ای برای فروش وجود ندارد" />
      ) : (
        items.map((item) => (
          <ProductBox key={item.id} showPic={showPic} item={item} select={select} />
        ))
      )}
    </ListContainer>
  );
};
export default List;
